// Turns a thrown mutation error (from the unified set-role / remove-member
// hooks) into the message we want users to read. The server returns
// HTTP 409 with `code === 'groups/cannot_demote_last_leader'` or
// `'groups/cannot_remove_last_leader'` when the action would leave the
// group with no leader; both surface a "promote someone else first"
// nudge. Everything else resolves through the caller's localized
// `useErrorMessage` resolver, then the supplied fallback.

import { GROUP_MEMBER_ERROR_CODES } from '../../lib/mutations/groups';
import { apiErrorCode } from '../../lib/api-error';
import type { DescribeError } from '../../lib/error-message';

export function formatGroupMemberError(
  err: unknown,
  describe: DescribeError,
  fallback: string,
  lastLeaderNudge: string,
): string {
  const code = apiErrorCode(err);

  if (
    code === GROUP_MEMBER_ERROR_CODES.cannotDemoteLastLeader ||
    code === GROUP_MEMBER_ERROR_CODES.cannotRemoveLastLeader
  ) {
    return lastLeaderNudge;
  }

  return describe(err, fallback);
}
